import type { SVGProps } from "react";

export function IconVideoCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="11"
      viewBox="0 0 14 11"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video check</title>
      <path
        d="M1 5.5 L5 9.5 L13 1.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
